module.exports = __webpack_public_path__ + "static/media/mlotto.a068f9dc.webp";